import React from 'react';
import { Button } from 'reactstrap';
class ShareBtn extends React.Component {


  shareClicked(e) {
    navigator.share({
      url: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
      text: "Sharing this song with you",
      title: "Best share"
    })
  }


  render() {

    return <Button color="primary" onClick={this.shareClicked} className="mt-5">{this.props.text}</Button>



  }
}

export default ShareBtn;
